import { useCallback } from "react";

interface ICsvExport {
  exportToCSV: <T,>(data: T[], headers: string [], filename: string) => void;
}

const useCsvExport = (): ICsvExport => {
  const convertToCSV = useCallback(<T,>(data: T[], headers: string[]): string => {
    if (data.length === 0) return "";

    const keys = Object.keys(data[0] as Record<string, string>);
    const csvRows = data.map(row =>
      keys.map(fieldName => `"${(row)[fieldName]}"`).join(",")
    );

    return [headers.join(","), ...csvRows].join("\n");
  }, []);

  const exportToCSV = useCallback(<T,>(data: T[], headers: string[], filename = "data.csv") => {
    const csvContent = convertToCSV(data, headers);
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }, [convertToCSV]);

  return { exportToCSV };
};

export default useCsvExport;
